// @flow

 const BASE_URL_II = 'https://260083nlx9.execute-api.us-east-1.amazonaws.com/pdev';

 /* const DEV_URL = 'https://9p9dy4z374.execute-api.us-east-1.amazonaws.com/dev';
 const DEV_URL_I = 'https://abt8sc23hl.execute-api.us-east-1.amazonaws.com/dev';
 const DEV_URL_II = 'https://jh2qflzfnh.execute-api.us-east-1.amazonaws.com/dev';
 const DEV_URL_III = 'https://jl6ltp48c0.execute-api.us-east-1.amazonaws.com/dev'; */
 // const SERVICES = 'https://api.dev.myrecruitboard.com/pr';
 // const DASHBOARD = 'https://api.dev.myrecruitboard.com/db';
 // const ELASTIC = 'https://api.dev.myrecruitboard.com/es';
 // const PAYMENT = 'https://api.dev.myrecruitboard.com/pg';
 // const DEV_URL_III = 'https://jl6ltp48c0.execute-api.us-east-1.amazonaws.com/dev';
//  const SERVICES = 'https://api.dev.myrecruitboard.com/pr';
//  const DASHBOARD = 'https://api.dev.myrecruitboard.com/db';
//  const ELASTIC = 'https://api.dev.myrecruitboard.com/es';
//  const PAYMENT = 'https://api.dev.myrecruitboard.com/pg';
//  const ADMIN = 'https://bevbzc9j32.execute-api.us-east-1.amazonaws.com/dev/admin';
 const SERVICES = `${process.env.REACT_APP_DEV_URL}/pr`;
 const DASHBOARD = `${process.env.REACT_APP_DEV_URL}/db`;
 const ELASTIC = `${process.env.REACT_APP_DEV_URL}/es`;
 const PAYMENT = `${process.env.REACT_APP_DEV_URL}/pg`;
 const ADMIN = process.env.REACT_APP_ADMIN_URL;

//  const SERVICES = 'https://api.myrecruitboard.com/pr';
//  const DASHBOARD = 'https://api.myrecruitboard.com/db';
//  const ELASTIC = 'https://api.myrecruitboard.com/es';
//  const PAYMENT = 'https://api.myrecruitboard.com/pg';
//  const ADMIN = 'https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin';

 export const SAVE_SA_PROFILE = `${SERVICES}/saProfile/add/`;
 export const UPDATE_SA_PROFILE = `${SERVICES}/saProfile/update/`;

 export const GET_SA_PROFILE = `${SERVICES}/saProfiles/get/`;
 export const ADD_SA_PROFILE_VIDEO = `${SERVICES}/saProfileVideo/add`;
 export const SA_PROFILE_SCHOOLS = `${SERVICES}/divisions/search`;

 // export const COACH_PROFILE_URL_ENDPOINT = `${DEV_URL}/saProfile/add/`;

 export const COACH_PROFILE_URL_ENDPOINT = `${SERVICES}/saProfile/add/`;

 // export const GET_SA_DASHBOARD_SCHOOLS = `${DEV_URL_II}/student/colleges`;

 export const GET_SA_DASHBOARD_SCHOOLS = `${ELASTIC}/student/colleges`;

 export const GET_SA_DASHBOARD_POSTINGS = `${ELASTIC}/student/postings`;


 export const SAVE_COACH_PROFILE = `${SERVICES}/coaches/add/`;
 export const GET_COACH_PROFILE = `${SERVICES}/coaches/get/`;


 export const ADD_POSTING = `${DASHBOARD}/postings/add`;
 export const GET_ALL_POSTINGS = `${DASHBOARD}/postings/getall/`;
 export const GET_POSTING_BY_ID = `${DASHBOARD}/postings/get/`;
 export const UPDATE_POSTING = `${DASHBOARD}/postings/update/`;
 export const DELETE_POSTING = `${DASHBOARD}/postings/delete/`;

 export const ADD_TO_WISHLIST = `${SERVICES}/saInterest/add`;
 export const REMOVE_FROM_LIST = `${SERVICES}/saInterest/delete`;

 export const ADD_TO_REQUEST = `${DASHBOARD}/requests/add`;

 export const COACH_GET_REQUEST_LIST = `${DASHBOARD}/requests/getbyclg/`;

 export const GET_COACH_DASHBOARD_REQUESTS = `${DASHBOARD}/requests/get/`;

// payment urls start
 export const GET_CLIENT_TOKEN = `${PAYMENT}/payment/client_token`;

 export const PUT_PAYMENT_NONCE = `${BASE_URL_II}/payment/customer/34b-37a8-51a0-9e5b-08f6547c7f3d`;

// payment urls end
 export const POST_SUBSCRIPTION = `${PAYMENT}/payment/subscribe`;

 export const POST_SUBSCRIPTION_CS = `${BASE_URL_II}/payment/customerCS`;

 export const GET_ATHLETE_BY_ID = `${SERVICES}/saProfiles/get_pubilc/`;

 export const GET_REQUEST_BY_ID = `${DASHBOARD}/requests/getbyid/`;

// Request urls

 export const ADD_CONVERSATION = `${DASHBOARD}/requests/add_conversation`;

 export const GET_PAYMENT_HISTORY = `${PAYMENT}/payment/transactions?customerId=`;

 export const SEND_CONTACT_MAIL = `${DASHBOARD}/sg/contact`;

 export const VALIDATE_COACH_FROM_DATABASE = `${ELASTIC}/coaches/checkdb`;

 export const GET_TOTAL_COUNTS_FOR_DASHBOARD = `${ELASTIC}/elastic/getCollegesCount`;

 export const ADD_COACH_APPLICATION = `${SERVICES}/coach_applications/add`;

 export const SEARCH_USER_ATHLETE = `${ELASTIC}/students/checkdb`;

 export const UPDATE_COACH_APPLICATION = `${SERVICES}/coache_applications/update`;

 export const GET_COACHES_APPLICATION = `${SERVICES}/coach_applications/getall/`;

 export const GET_ATHLETE_FOR_COACH_BY_ID = `${DASHBOARD}/requestTracker/get/`;

 // export const DELETE_ATHLETE_VIDEO_BY_INDEX = 'https://noq1rs9sik.execute-api.us-east-1.amazonaws.com/dev/removeVideos';
 export const DELETE_ATHLETE_VIDEO_BY_INDEX = `${ADMIN}/removeVideos`;

 export const UPGRADE_STUDENT = `${ADMIN}/upgradeStudent`;

 export const OVERRIDE_DIVISION = `${ADMIN}/overrideStudent`;

 export const STUDENT_EVALUATION = `${ADMIN}/studentEvaluation`;

 export const DELETE_COACH = `${ADMIN}/deleteCoach`;

 export const MODIFY_COLLEGE = `${ADMIN}/modifyCollege`;

 export const ADD_COACH = `${ADMIN}/addCoach`;

 export const GET_COACHES_FROM_COLLEGES = `${SERVICES}/coaches/getall/`;

 export const ADD_COLLEGE_TO_DB = `${SERVICES}/college/admin/addCollege`;

 export const ADD_STUDENT_CURRENT_DIVISION = `${SERVICES}/saProfile/addCurrentDivision`;

 export const GET_DIVISION_BASED_STUDENTS = `${SERVICES}/saProfile/getAllStudentsByDivision`;


 export const GET_FILTER_BASED_STUDENTS = `${SERVICES}/saProfile/filterDivisionStudents`;

 export const GET_TOTAL_REQUEST_VIEWED_COUNT = `${DASHBOARD}/requests/getCounts/`;

 export const GET_STUDENTS_FOR_STUDENT_EXPLORER = `${ADMIN}/getDivisionBasedStudents`;

 export const DELETE_COCAH_APPLICATION = `${ADMIN}/deleteCoachApplication/`;

 export const RESET_STUDENT_DASHBOARD = `${ADMIN}/reset/dashboard/`;

 export const UPDATE_STUDENT_TRIAL = `${DASHBOARD}/user/trial`;



// WEBPACK FOOTER //
// ./src/common/constants/urls.js